<template>
  <!-- the lot navigation component -->
  <div
    v-if="!!item"
    class="lot-navigation flexBoxSpread"
  >
    <div>
      <span v-if="prev_link">
        <a
          id="previous-lot"
          :href="prev_link"
        >
          <span class="chevron-icon">&#8249;</span>
          Previous
        </a>
      </span>
    </div>
    <div>
      <span v-if="next_link">
        <a
          id="next-lot"
          :href="next_link"
        >
          Next <span class="chevron-icon">&#8250;</span>
        </a>
      </span>
    </div>
  </div>
</template>

<script>

export default {
	name: 'LotNavigation',
	props: [
		'item_id'
	],
	data () {
		return {
			next_link: '',
            prev_link: '',
		}
	},
	computed: {
		item: function () {
			return this.$store.getters.item(this.item_id)
		},
	},
	mounted () {
		const path = window.location
		let apiPayload = {}
		const url = window.location.href;

		if(path.search.includes('departmentId')){
			const itemsId = url.match(/\/items\/(\d+)/);
			const departmentId = url.match(/departmentId=(\d+)/);
			const itemIdValue = itemsId ? itemsId[1] : null;
			const departmentIdValue = departmentId ? departmentId[1] : null;

			apiPayload.apiEndpoint = 'search'
			apiPayload.postData = {}
			apiPayload.postData.action = 'navigate'
			apiPayload.postData.inventory_id = itemIdValue
			apiPayload.postData.department_id = departmentIdValue
		} 
		else if(path.search.includes('listId') && path.search.includes('categoryId')) {
			const itemsId = url.match(/\/items\/(\d+)/);
			const listId = url.match(/listId=(\d+)/);
			const categoryId = url.match(/categoryId=(\d+)/);
			const itemIdValue = itemsId ? itemsId[1] : null;
			const listIdValue = listId ? listId[1] : null;
			const categoryIdValue = categoryId ? categoryId[1] : null;
			
			apiPayload.apiEndpoint = 'search'
			apiPayload.postData = {}
			apiPayload.postData.action = 'navigate'
			apiPayload.postData.inventory_id = itemIdValue
			apiPayload.postData.list_id = listIdValue
			apiPayload.postData.category_id = categoryIdValue
		}
		else if(path.search.includes('listId') && path.search.includes('provenanceId')) {
			const itemsId = url.match(/\/items\/(\d+)/);
			const listId = url.match(/listId=(\d+)/);
			const provenanceId = url.match(/provenanceId=(\d+)/);
			const itemIdValue = itemsId ? itemsId[1] : null;
			const listIdValue = listId ? listId[1] : null;
			const provenanceIdValue = provenanceId ? provenanceId[1] : null;
			
			apiPayload.apiEndpoint = 'search'
			apiPayload.postData = {}
			apiPayload.postData.action = 'navigate'
			apiPayload.postData.inventory_id = itemIdValue
			apiPayload.postData.list_id = listIdValue
			apiPayload.postData.provenance_id = provenanceIdValue
		}  
		else if(path.search.includes('listId')) {
			const itemsId = url.match(/\/items\/(\d+)/);
			const listId = url.match(/listId=(\d+)/);
			const itemIdValue = itemsId ? itemsId[1] : null;
			const listIdValue = listId ? listId[1] : null;

			apiPayload.apiEndpoint = 'search'
			apiPayload.postData = {}
			apiPayload.postData.action = 'navigate'
			apiPayload.postData.inventory_id = itemIdValue
			apiPayload.postData.list_id = listIdValue
		}
		
		if(Object.keys(apiPayload).length > 0){
			this.$store.dispatch('apiCall', apiPayload).then(response => {
				// console.log(response)
				if(response.data.result == 'success'){
					this.next_link = response.data.payload.next
					this.prev_link = response.data.payload.previous
				}
			})
		}
	}
}
</script>

<style scoped>
.lot-navigation {
	margin-top: 0.25em;
	margin-bottom: 0.5em;
}
.lot-navigation a {
	font-size: 1em;
}
.chevron-icon {
	font-size: 1.5em;
	line-height: 1em;
	font-family: monospace;
}
</style>
